import styled from 'styled-components';

import { Flex } from '../../../lib/components/LessonPath/static/style';

export const ContentBox = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    width: ${props => props.width ? props.width : '7.4rem'};
    height: ${props => props.width ? props.width : '7.2rem'};
    background: url(${props => props.image ? require('./img/' + props.image + '.png') : require('./img/buy-course-bg.png')}) no-repeat center;
    background-size: contain;
    color: #292929;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
`;

export const ContentClose = styled.div`
    position: absolute;
    bottom: -1.5rem;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    width: 1rem;
    height: 1rem;
    background: url(${require('./img/close-icon.png')}) no-repeat center;
    background-size: contain;
`;

export const ButtonBox = styled.div`
    position: absolute;
    bottom: 0.5rem;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
`;

export const Button = styled.div`
    position: absolute;
    width: 3rem;
    height: 100%;
    color: #fff;
    border-radius: 0.4rem;
    top: 0;
    cursor: pointer;

    ${props => props.type === 'left' ? `
        left: 0.5rem;
        background: #AF69FF;
    ` : `
        right: 0.5rem;
        background: linear-gradient(to right bottom, #FFAF96, #FF6E64);
    `}
`;

export const DialogContent = styled(Flex)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    width: 8rem;
    height: 4rem;
    background: #fff;
    border-radius: 0.4rem;
    flex-direction: column;
    justify-content: space-between;
    font-size: 0.4rem;
`;

export const DialogText = styled.div`
    flex: 1;
    padding: 1rem 0.7rem 0;
`;

export const DialogButton = styled.div`
    border-top: 0.02rem solid #EAEAEA;
    height: 1.1rem;
    line-height: 1.1rem;
    text-align: center;
    color: #0262DA;
    cursor: pointer;
`;


// WEBPACK FOOTER //
// ./src/components/dialog/static/style.js